import { render, staticRenderFns } from "./SalesAssessmentDetail.vue?vue&type=template&id=2b3e0cfa&scoped=true"
import script from "./SalesAssessmentDetail.vue?vue&type=script&lang=js"
export * from "./SalesAssessmentDetail.vue?vue&type=script&lang=js"
import style0 from "./SalesAssessmentDetail.vue?vue&type=style&index=0&id=2b3e0cfa&prod&scoped=true&lang=css"
import style1 from "./SalesAssessmentDetail.vue?vue&type=style&index=1&id=2b3e0cfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e0cfa",
  null
  
)

export default component.exports